import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil, timer } from 'rxjs';
import { LoggerService } from 'src/app/services/logger.service';
import { ALERT_DURATION, ALERT_STACK_LENGTH, EAlertType, IAlertObject } from './alert.constants';
import { AlertService } from './alert.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.9)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'scale(0.9)' }))
      ])
    ])
  ]
})
export class AlertComponent implements OnInit, OnDestroy {

  alertStack: IAlertObject[] = [];
  destroy$ = new Subject();

  constructor(
    private readonly _alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.watchAlerts();
  }

  watchAlerts() {
    this._alertService.alertSubscription
      .pipe(takeUntil(this.destroy$))
      .subscribe(alertObject => {
        this.addItem(alertObject);
      })
  }

  getAlertClass(alert: IAlertObject): string {
    switch (alert.type) {
      case EAlertType.ERROR:
        return 'alert-red';
      case EAlertType.WARNING:
        return 'alert-yellow';
      default:
        return 'alert-green';
    }
  }

  getIconName(alert: IAlertObject): string {
    switch (alert.type) {
      case EAlertType.ERROR:
        return 'error';
      case EAlertType.WARNING:
        return 'warning';
      default:
        return 'check_circle';
    }
  }

  addItem(obj: IAlertObject) {
    LoggerService.logInfo(this.constructor.name, 'addItem', { obj });
    this.alertStack.push(obj);
    if (this.alertStack.length > ALERT_STACK_LENGTH) {
      this.alertStack.shift();
    }
    timer(ALERT_DURATION)
    .pipe(takeUntil(this.destroy$))
    .subscribe(() => this.removeItem(obj));
  }

  removeItem(obj: IAlertObject) {
    LoggerService.logInfo(this.constructor.name, 'removeItem', { obj });
    const index = this.alertStack.findIndex(x => x.message === obj.message);
    if (index !== -1) {
      this.alertStack.splice(index, 1);
    }
  }

  closeAlert(index: number) {
    LoggerService.logInfo(this.constructor.name, 'closeAlert', { index });
    this.alertStack.splice(index, 1);
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
